import { render } from "./Broadcast.vue?vue&type=template&id=e1fab410&scoped=true"
import script from "./Broadcast.vue?vue&type=script&lang=js"
export * from "./Broadcast.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e1fab410"

export default script